'use strict';

import React, { Component } from 'react'

import Layout   from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'
import ProductCard     from '@/ProductCard'
import Pagination      from '@/Pagination'

import { handleChange } from '@/Form/Functions/eventsHandling'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'

import request from '@function/ajax/request'

import Config from '@Config/Catalog/show_product'

import { num } from '@root/utility'

const delay_options = Config.fields['online_type'].options
.filter(opt => opt.value !== 'none');

const app = window.app;

const qwest = window.qwest;

const hidden_place_themes =
[
	'5a664f2b464daed256b231ba', // Bon Achat - Carte Cadeau
	'62398e0cd0dff85f7c10eb4c'  // Concerts et spectacles
];

const PER_PAGE = 30;

export default class CatalogPage extends Component
{
	state =
	{
		references: [],
		place_themes: [],

		online_type: app.state.search_data.catalogPage_online_type || 'all',

		searched_place_theme: app.state.search_data.catalogPage_place_theme || 'all',
		searched_theme: app.state.search_data.catalogPage_theme || 'all',

		data: [],
		data_count: 0,
		page: 0,

		pagination:
		{
			max_items: 30,
			limit: 30,
			skip: 0
		},

		searched: '',
		delayed_search: ''
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		component.fetchProducts();

		qwest.post('/CMS/getAll',
		{
			model: 'PlaceTheme'.toLowerCase()
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,

				place_themes: (response.data || [])
				.filter(theme => hidden_place_themes.includes(theme.id) === false)
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handleChange = handleChange.bind(this);

	componentDidUpdate (prev_props, prev_state)
	{
		const component = this, props = this.props, state = this.state;

		if (prev_state.page !== state.page ||
			prev_state.delayed_search !== state.delayed_search)
		{
			component.fetchProducts();
		}
	}

	fetchProducts = async () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		try
		{
			var { data, count } = await request('/front/fetch-tickets')
			.config({ keyword: 'action' })
			.post(
			{
				online_type: app.state.search_data.catalogPage_online_type || 'all',
				place_theme: app.state.search_data.catalogPage_place_theme || 'all',

				skip: state.page * PER_PAGE,
				limit: PER_PAGE,

				searched: state.delayed_search
			});
		}
		catch (update)
		{
			if (update === 'ABORTED') return;

			return component.setState(update);
		}

		component.setState(
		{
			loading: false,
			data: data || [],
			data_count: num(count, 0)
		});
	}

	resetFilter = (name) =>
	{
		const component = this, props = this.props, state = this.state;

		if (name === 'searched_place_theme')
		{
			component.setState(
			{
				searched_place_theme: 'all'
			});

			app.state.search_data.catalogPage_place_theme = 'all';
		}
		else if (name === 'online_type')
		{
			component.setState(
			{
				online_type: 'all'
			});

			app.state.search_data.catalogPage_online_type = 'all';
		}

		component.fetchProducts();
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		if (component.search_timeout)
		{
			window.clearTimeout(component.search_timeout);
		}

		component.search_timeout = window.setTimeout(function ()
		{
			component.search_timeout = undefined;

			component.setState(
			{
				delayed_search: value || ''
			});
		},
		400);

		component.setState({ searched: value || '' });
	}

	handleOnlineTypeChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ online_type: e.target.value });

		app.state.search_data.catalogPage_online_type = e.target.value;

		component.fetchProducts();
	}

	handlePlaceThemeChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			searched_place: e.target.value
		});

		app.state.search_data.catalogPage_place_theme = e.target.value;

		component.fetchProducts();
	}

	handlePageChange = (e, page) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		component.setState({ page: page });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-light'] } />
		)
		: undefined;

		const place_themes = state.place_themes
		.sort(function (a, b)
		{
			return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
		})
		.map(function (theme)
		{
			let output =
			(
				<option value={ theme.id } key={ theme.id }>{ theme.label }</option>
			);

			return output;
		});

		const products = (state.data || []).map(function (product)
		{
			return (
				<ProductCard product={ product } key={ product.id } />
			);
		});

		const options = delay_options.map(function ({ value, label='' })
		{
			return (
				<option value={ value } key={ value }>{ label }</option>
			);
		});

		var output =
		(
			<Layout history={ props.history } page_title="Catalogue">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">Billetteries</h2>
						</div>

						<div className="front-dashboard-search">
							<SearchBar className="c-searchbar c-searchbar--front"
								hide_btn={ true } placeholder="Rechercher dans les produits"
								data={ [] }
								handleChange={ component.handleSearch }
								value={ state.searched.value }
							/>

							<div className="front-dashboard-search__theme-label">
								Thème
							</div>

							<select className="c-form__input
								front-dashboard-search__theme"
								name="page-search-theme"
								onChange={ component.handlePlaceThemeChange }
								value={ state.searched_place }
								id={ (props.id_prefix || '') + state.id }>
								<option value="all">Tous</option>
								{ place_themes }
							</select>

							<button className="reset-page-filters" type="button"
								title="effacer" onClick={ function (e)
									{ component.resetFilter('searched_place_theme'); } }>
								<div className="reset-page-filters-icon"></div>
							</button>

							<div className="front-dashboard-search__theme-label">
								Délai de livraison
							</div>

							<select className="c-form__input
								front-dashboard-search__online-type"
								name="page-search-online-type"
								onChange={ component.handleOnlineTypeChange }
								value={ state.online_type }>
								<option value="all">Tous</option>
								{ options }
							</select>

							<button className="reset-page-filters" type="button"
								title="effacer" onClick={ function (e)
									{ component.resetFilter('online_type'); } }>
								<div className="reset-page-filters-icon"></div>
							</button>

						</div>

						<div className="u-full-width u-positioned">

							{
								loader && !products.length ?
								(
									<div className="u-full-width u-positioned
										u-padding-top-30 u-padding-bottom-30">
										{ loader }
									</div>
								)
								: loader
							}

							{
								products.length ?
								(
									<div className="u-negative-margin">
										<div className="o-grid-5 u-flex">
											{ products }
										</div>
									</div>
								)
								: undefined
							}

						</div>

						<Pagination current={ state.page } total={ state.data_count }
							items-per-page={ PER_PAGE }
							onChange={ component.handlePageChange }
						/>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}